export enum MCP_MARKET_ENVIRONMENTS {
  LTA = 'LTA',
  LJE = 'LJE',
}
export enum MCP_MARKET_ENVIRONMENT_COUNTRY_CODES {
  IRELAND = 'ie',
  SPAIN = 'es',
  ITALY = 'it',
  UK = 'uk',
  AUSTRALIA = 'au',
  LEGACY_TAKEAWAY = 'L-TA',
}

class MCPMarketEnvironmentDetection {
  static extractCountryCodePartFromStagingUrl(urlString: string) {
    if (typeof urlString !== 'string') {
      console.error('Not a valid url');
      return null;
    }

    const regex = /courierapp-([a-zA-Z0-9-]+)\./;
    const match = regex.exec(urlString);

    if (match && match[1]) {
      return match[1];
    } else {
      return null;
    }
  }

  static extractCountryCodePartFromProductionUrl(urlString: string) {
    if (typeof urlString !== 'string' || urlString.trim() === '') {
      return null;
    }

    const regex = /\.(it|es|ie|uk)$/;
    const match = urlString.match(regex);

    if (match && match[1]) {
      return match[1];
    } else {
      return null;
    }
  }

  static getMarketEnvironment() {
    const domain = location.hostname;
    let currentCountryCode = null;

    if (process.env.NODE_ENV !== 'production') {
      const countryCode = this.extractCountryCodePartFromStagingUrl(domain);
      if (!countryCode) {
        currentCountryCode = MCP_MARKET_ENVIRONMENT_COUNTRY_CODES.LEGACY_TAKEAWAY;
      } else {
        currentCountryCode = countryCode;
      }
    } else {
      const countryCode = this.extractCountryCodePartFromProductionUrl(domain);
      if (!countryCode) {
        currentCountryCode = MCP_MARKET_ENVIRONMENT_COUNTRY_CODES.LEGACY_TAKEAWAY;
      } else {
        currentCountryCode = countryCode;
      }
    }

    return {
      countryCode: currentCountryCode,
      market:
        currentCountryCode !== MCP_MARKET_ENVIRONMENT_COUNTRY_CODES.LEGACY_TAKEAWAY
          ? MCP_MARKET_ENVIRONMENTS.LJE
          : MCP_MARKET_ENVIRONMENTS.LTA,
    };
  }
}

export default MCPMarketEnvironmentDetection;
